// extracted by mini-css-extract-plugin
module.exports = {"emailVerification":"KgcUbsaDKzzu-3BWhL-4M","logo":"_3Bqg4tzTTuONUstRinldFs","content":"_2hKeVu7dUy0Ai1yskRorSW","resendButtons":"_34938eTUMm9ao_IN41csBx"};